import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { SsoTableSsoFragment } from './__generated__/SsoTable.graphql';

interface Props {
  sso: SsoTableSsoFragment | null;
  isOpen: boolean;
  onCancel: () => void;
  onDelete: () => void;
  isLoading?: boolean;
}

export function DeleteSsoModal({ sso, isOpen, onCancel, onDelete, isLoading }: Props) {
  const { t } = useTranslation();

  const handleClose = useCallback(() => {
    onCancel();
  }, [onCancel]);

  const handleDelete = useCallback(() => {
    onDelete();
  }, [onDelete]);

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('deleteSsoTitle')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            <Trans
              i18nKey="deleteSsoConfirm"
              values={{ domain: sso?.domain }}
              components={{ strong: <strong /> }}
            />
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button onClick={handleClose} variant="ghost" colorScheme="blue" mr={3}>
            {t('cancel')}
          </Button>
          <Button onClick={handleDelete} colorScheme="red" isLoading={isLoading}>
            {t('delete')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
